export default "/images/vendor/flag-icon-css/flags/4x3/iq.svg?5cd51d2bbb7385580434ed831dbdf8ca";